import { isIos, isSafari } from '@braintree/browser-detection';
import { useState } from 'react';

import defaultPeterPicture from '~/src/assets/default/peter.jpg?as=manifest&format=jpg;avif;webp&w=500';
import defaultPicture from '~/src/assets/default/user.png?as=manifest&format=jpg;avif;webp&w=500';

import { getPictureLink, pickSmallestSupportedSourceUrl } from '../../../common/resizer';
import Action from '../../Action';
import brickstarsPicture from './assets/brickstars.png?as=manifest&format=png;avif;webp&w=300';
import brickstarsVideo from './assets/brickstars.webm';

import * as style from './style.module.css';

const UserPicture = ({ picture = null, imageWidth = 400, animatedPicture = null, theme = "NONE", id = null, role = 'USER', isPeter = false, login = '', slug = '', isOnline = false, className = '', showBorders = false, size = null, action = null, children = null }) => {
  const computedAction = action || (id && !isPeter ? `/users/${id}/${slug}` : ['PREMIUM', 'MODERATOR', 'ADMINISTRATOR'].includes(role) ? `/users/?tag=${role.toLowerCase()}` : null);
  const image = getPictureLink(picture, { w: imageWidth });
  const [isLoaded, setIsLoaded] = useState([false, false]);
  const loadingStateHandler = (idx) => () => setIsLoaded(old => idx === 0 ? [true, old[1]] : [old[0], true]);
  const showThumbnail = isLoaded[0] && (!picture || (picture && isLoaded[1]));

  const isTransparentVideoCompatible = !isIos() && !isSafari();
  const showBrickstarsTheme = theme === 'BRICKSTARS';

  return (
    <Action style={size ? { '--size': size } : {}} title={login} action={computedAction} className={`${style.userPicture} ${showBorders && !showBrickstarsTheme ? style.borders : ''} ${className}`}>
      {showBrickstarsTheme && <div className={isTransparentVideoCompatible ? style.glow : style.glowWithoutAnimation} />}
      <div className={style.content}>
        <img className={`${style.contentItem} ${showThumbnail ? style.contentItemShow : ''}`} onLoad={loadingStateHandler(0)} onError={loadingStateHandler(0)} src={pickSmallestSupportedSourceUrl(isPeter ? defaultPeterPicture : defaultPicture)} loading="lazy" />
        {!isPeter && picture && <img className={`${style.contentItem} ${showThumbnail ? style.contentItemShow : ''}`} onLoad={loadingStateHandler(1)} onError={loadingStateHandler(1)} src={image} loading="lazy"/>}
        {animatedPicture && <video poster={image} className={`${style.contentItem} ${style.contentItemShow}`} src={animatedPicture} muted loop autoPlay playsInline={true} disablePictureInPicture={true} controlsList="nodownload" />}
        {animatedPicture && <div className={`${style.contentItem} ${style.contentItemShow}`} />}
        {showBrickstarsTheme && <div className={style.brickstarsShadow} />}
      </div>
      {showBrickstarsTheme && <div className={style.brickstarsOverlay}>
        {isTransparentVideoCompatible && <video src={brickstarsVideo} poster={pickSmallestSupportedSourceUrl(brickstarsPicture)} autoPlay playsInline={true} muted disablePictureInPicture={true} controlsList="nodownload" />}
        {!isTransparentVideoCompatible && <img src={pickSmallestSupportedSourceUrl(brickstarsPicture)} />}
      </div>}
      {isOnline && <div className={style.online} />}
      {children}
    </Action>
  );
};

export default UserPicture;
